"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestBroadcastResponseSchema = exports.TestBroadcastRequestSchema = exports.BroadcastAudienceSchema = exports.UpdateBroadcastRequestSchema = exports.CreateBroadcastRequestSchema = exports.BroadcastListSchema = exports.AdminBroadcastListQuerySchema = exports.BroadcastDetailSchema = exports.BroadcastSummarySchema = exports.BroadcastProgressSchema = exports.BroadcastTextSchema = exports.BroadcastRecipientStatusSchema = exports.BroadcastStatusSchema = void 0;
const zod_1 = require("zod");
const locale_1 = require("../../locale");
const telegram_html_1 = require("../../telegram-html");
const common_1 = require("./common");
exports.BroadcastStatusSchema = zod_1.z.enum([
    'draft',
    'sending',
    'completed',
    'cancelled',
    'archived',
]);
exports.BroadcastRecipientStatusSchema = zod_1.z.enum([
    'queued',
    'sent',
    'failed',
    'blocked',
    'skipped',
]);
/** Restricted Telegram HTML (spec §4.1); every parser issue becomes a zod issue on the field. */
exports.BroadcastTextSchema = zod_1.z
    .string()
    .min(1)
    .max(telegram_html_1.BROADCAST_TEXT_MAX_LENGTH)
    .superRefine((value, ctx) => {
    for (const issue of (0, telegram_html_1.validateTelegramHtml)(value))
        ctx.addIssue({ code: 'custom', message: `${issue.message} at ${issue.offset}` });
});
exports.BroadcastProgressSchema = zod_1.z.object({
    queued: zod_1.z.number().int().nonnegative(),
    sent: zod_1.z.number().int().nonnegative(),
    failed: zod_1.z.number().int().nonnegative(),
    blocked: zod_1.z.number().int().nonnegative(),
    skipped: zod_1.z.number().int().nonnegative(),
});
exports.BroadcastSummarySchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    title: zod_1.z.string(),
    status: exports.BroadcastStatusSchema,
    /** Null until the dispatcher has enumerated the audience. */
    totalRecipients: zod_1.z.number().int().nonnegative().nullable(),
    progress: exports.BroadcastProgressSchema,
    createdBy: common_1.StaffRefSchema,
    updatedBy: common_1.StaffRefSchema,
    startedAt: zod_1.z.iso.datetime().nullable(),
    finishedAt: zod_1.z.iso.datetime().nullable(),
    createdAt: zod_1.z.iso.datetime(),
    updatedAt: zod_1.z.iso.datetime(),
});
exports.BroadcastDetailSchema = exports.BroadcastSummarySchema.extend({
    textUk: zod_1.z.string(),
    textEn: zod_1.z.string(),
    dispatchedAt: zod_1.z.iso.datetime().nullable(),
});
/** Without `status` the list shows every status except `archived`. */
exports.AdminBroadcastListQuerySchema = common_1.CursorQuerySchema.extend({
    status: exports.BroadcastStatusSchema.optional(),
});
exports.BroadcastListSchema = (0, common_1.pageSchema)(exports.BroadcastSummarySchema);
exports.CreateBroadcastRequestSchema = zod_1.z.object({
    title: zod_1.z.string().trim().min(1).max(telegram_html_1.BROADCAST_TITLE_MAX_LENGTH),
    textUk: exports.BroadcastTextSchema,
    textEn: exports.BroadcastTextSchema,
});
exports.UpdateBroadcastRequestSchema = exports.CreateBroadcastRequestSchema.partial().refine((body) => body.title !== undefined || body.textUk !== undefined || body.textEn !== undefined, { message: 'Nothing to update' });
exports.BroadcastAudienceSchema = zod_1.z.object({ count: zod_1.z.number().int().nonnegative() });
exports.TestBroadcastRequestSchema = zod_1.z.object({ userId: zod_1.z.uuid() });
/** Which language versions reached Telegram, in send order (uk first). */
exports.TestBroadcastResponseSchema = zod_1.z.object({ sent: zod_1.z.array(zod_1.z.enum(locale_1.LOCALES)) });
//# sourceMappingURL=broadcasts.js.map